export default __webpack_public_path__ + "static/media/eye-partial.238c120b.svg";